import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrandCampaignSelectionState {
  selectedRows: number[]; // currently selected DoctorVisitIds
  previouslySelectedRows: number[]; // stores selection before "select all"
  selectAll: boolean; // toggle select all state
}

const initialState: BrandCampaignSelectionState = {
  selectedRows: [],
  previouslySelectedRows: [],
  selectAll: false,
};

const brandCampaignStepSelectionSlice = createSlice({
  name: "brandCampaignSelection",
  initialState,
  reducers: {
    toggleRowSelection: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      if (state.selectedRows.includes(id)) {
        state.selectedRows = state.selectedRows.filter((rowId) => rowId !== id);
      } else {
        state.selectedRows.push(id);
      }
    },
    selectAllRows: (state, action: PayloadAction<number[]>) => {
      // Save current selection before selecting all
      state.previouslySelectedRows = [...state.selectedRows];
      state.selectedRows = []; // all ids from current page
      state.selectAll = true;
    },
    unselectAllRows: (state) => {
      // Revert to previously selected rows
      state.selectedRows = [...state.previouslySelectedRows];
      state.previouslySelectedRows = [];
      state.selectAll = false;
    },
    resetSelection: (state) => {
      state.selectedRows = [];
      state.previouslySelectedRows = [];
      state.selectAll = false;
    },
  },
});

export const {
  toggleRowSelection,
  selectAllRows,
  unselectAllRows,
  resetSelection,
} = brandCampaignStepSelectionSlice.actions;

export default brandCampaignStepSelectionSlice.reducer;
